/** Per-field plausible ranges (PSD §3.2). */
export const FIELD_RANGES = {
    ageYears: { field: 'ageYears', min: 18, max: 120, unit: 'years' },
    heightCm: { field: 'heightCm', min: 100, max: 250, unit: 'cm' },
    actualWeightKg: { field: 'actualWeightKg', min: 30, max: 300, unit: 'kg' },
    scrMgDl: { field: 'scrMgDl', min: 0.1, max: 20, unit: 'mg/dL' },
    bunMgDl: { field: 'bunMgDl', min: 1, max: 100, unit: 'mg/dL' },
};
/** Validate a single numeric value against a range; returns error string or null. */
export function validateRange(value, min, max, fieldName, unit = '') {
    if (value == null || Number.isNaN(value))
        return `${fieldName} is required.`;
    if (value < min)
        return `${fieldName} must be between ${min} and ${max} ${unit}.`.trim();
    if (value > max)
        return `${fieldName} must be between ${min} and ${max} ${unit}.`.trim();
    return null;
}
/** Validate a whole PatientInput object. */
export function validatePatientInput(patient) {
    const errors = {};
    for (const [key, range] of Object.entries(FIELD_RANGES)) {
        const v = patient[key];
        if (typeof v === 'number') {
            const msg = validateRange(v, range.min, range.max, key, range.unit);
            if (msg)
                errors[key] = msg;
        }
    }
    if (patient.ageYears != null && patient.ageYears < 18) {
        errors.ageYears = 'Adult patients only (≥ 18 years). Pediatric pathway is Phase 3.';
    }
    return { isValid: Object.keys(errors).length === 0, errors };
}
/** Detect implausible inputs (looser bounds — beyond which results are not trustworthy). */
export function checkImplausibleInputs(patient) {
    const flags = [];
    const checks = [
        ['ageYears', patient.ageYears, [18, 120], 'Age outside plausible adult range'],
        ['heightCm', patient.heightCm, [120, 213], 'Height outside plausible range'],
        ['actualWeightKg', patient.actualWeightKg, [35, 250], 'Weight outside plausible range'],
        ['scrMgDl', patient.scrMgDl, [0.2, 15], 'SCr outside plausible range'],
        ['bunMgDl', patient.bunMgDl, [1, 100], 'BUN outside plausible range'],
    ];
    for (const [field, value, validRange, reason] of checks) {
        if (typeof value === 'number' && (value < validRange[0] || value > validRange[1])) {
            flags.push({ field, value, reason, validRange });
        }
    }
    return flags;
}
//# sourceMappingURL=validation.js.map